import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _19027065 = () => interopDefault(import('../../../pages/over-ons.vue' /* webpackChunkName: "pages/over-ons" */))
const _bfd1b8ee = () => interopDefault(import('../../../pages/certificeringen.vue' /* webpackChunkName: "pages/certificeringen" */))
const _e64111b4 = () => interopDefault(import('../../../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _37e8fae4 = () => interopDefault(import('../../../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _149e31ac = () => interopDefault(import('../../../pages/security.vue' /* webpackChunkName: "pages/security" */))
const _d65ee660 = () => interopDefault(import('../../../pages/snowglobe.vue' /* webpackChunkName: "pages/snowglobe" */))
const _1f78dcb4 = () => interopDefault(import('../../../pages/werk/index.vue' /* webpackChunkName: "pages/werk/index" */))
const _0e934eac = () => interopDefault(import('../../../pages/research/dnzb.vue' /* webpackChunkName: "pages/research/dnzb" */))
const _29eb529e = () => interopDefault(import('../../../pages/research/erasmus-mc.vue' /* webpackChunkName: "pages/research/erasmus-mc" */))
const _1f1b3ebf = () => interopDefault(import('../../../pages/research/fagron.vue' /* webpackChunkName: "pages/research/fagron" */))
const _151c6077 = () => interopDefault(import('../../../pages/research/nines.vue' /* webpackChunkName: "pages/research/nines" */))
const _4033288c = () => interopDefault(import('../../../pages/research/tuuring.vue' /* webpackChunkName: "pages/research/tuuring" */))
const _25e8167a = () => interopDefault(import('../../../pages/werk/belmond.vue' /* webpackChunkName: "pages/werk/belmond" */))
const _4cd07f35 = () => interopDefault(import('../../../pages/werk/bobbys.vue' /* webpackChunkName: "pages/werk/bobbys" */))
const _aad76640 = () => interopDefault(import('../../../pages/werk/cbre.vue' /* webpackChunkName: "pages/werk/cbre" */))
const _ca868180 = () => interopDefault(import('../../../pages/werk/dnzb.vue' /* webpackChunkName: "pages/werk/dnzb" */))
const _35ab0992 = () => interopDefault(import('../../../pages/werk/erasmus-mc-intranet.vue' /* webpackChunkName: "pages/werk/erasmus-mc-intranet" */))
const _46aada53 = () => interopDefault(import('../../../pages/werk/fagron.vue' /* webpackChunkName: "pages/werk/fagron" */))
const _f737c5b6 = () => interopDefault(import('../../../pages/werk/ferring.vue' /* webpackChunkName: "pages/werk/ferring" */))
const _1e9c2744 = () => interopDefault(import('../../../pages/werk/jump-the-q.vue' /* webpackChunkName: "pages/werk/jump-the-q" */))
const _0e210263 = () => interopDefault(import('../../../pages/werk/nines.vue' /* webpackChunkName: "pages/werk/nines" */))
const _89d6216e = () => interopDefault(import('../../../pages/werk/rembrandt.vue' /* webpackChunkName: "pages/werk/rembrandt" */))
const _21923d5f = () => interopDefault(import('../../../pages/werk/sonnema-1860.vue' /* webpackChunkName: "pages/werk/sonnema-1860" */))
const _2dfb1658 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us/",
    component: _19027065,
    pathToRegexpOptions: {"strict":true},
    name: "over-ons___en"
  }, {
    path: "/certifications/",
    component: _bfd1b8ee,
    pathToRegexpOptions: {"strict":true},
    name: "certificeringen___en"
  }, {
    path: "/contact/",
    component: _e64111b4,
    pathToRegexpOptions: {"strict":true},
    name: "contact___en"
  }, {
    path: "/privacy/",
    component: _37e8fae4,
    pathToRegexpOptions: {"strict":true},
    name: "privacy___en"
  }, {
    path: "/security/",
    component: _149e31ac,
    pathToRegexpOptions: {"strict":true},
    name: "security___en"
  }, {
    path: "/snowglobe/",
    component: _d65ee660,
    pathToRegexpOptions: {"strict":true},
    name: "snowglobe___en"
  }, {
    path: "/work/",
    component: _1f78dcb4,
    pathToRegexpOptions: {"strict":true},
    name: "werk___en"
  }, {
    path: "/research/dnzb/",
    component: _0e934eac,
    pathToRegexpOptions: {"strict":true},
    name: "research-dnzb___en"
  }, {
    path: "/research/erasmus-mc/",
    component: _29eb529e,
    pathToRegexpOptions: {"strict":true},
    name: "research-erasmus-mc___en"
  }, {
    path: "/research/fagron/",
    component: _1f1b3ebf,
    pathToRegexpOptions: {"strict":true},
    name: "research-fagron___en"
  }, {
    path: "/research/nines/",
    component: _151c6077,
    pathToRegexpOptions: {"strict":true},
    name: "research-nines___en"
  }, {
    path: "/research/tuuring/",
    component: _4033288c,
    pathToRegexpOptions: {"strict":true},
    name: "research-tuuring___en"
  }, {
    path: "/work/belmond/",
    component: _25e8167a,
    pathToRegexpOptions: {"strict":true},
    name: "werk-belmond___en"
  }, {
    path: "/work/bobbys/",
    component: _4cd07f35,
    pathToRegexpOptions: {"strict":true},
    name: "werk-bobbys___en"
  }, {
    path: "/work/cbre/",
    component: _aad76640,
    pathToRegexpOptions: {"strict":true},
    name: "werk-cbre___en"
  }, {
    path: "/work/dnzb/",
    component: _ca868180,
    pathToRegexpOptions: {"strict":true},
    name: "werk-dnzb___en"
  }, {
    path: "/work/erasmus-mc-intranet/",
    component: _35ab0992,
    pathToRegexpOptions: {"strict":true},
    name: "werk-erasmus-mc-intranet___en"
  }, {
    path: "/work/fagron/",
    component: _46aada53,
    pathToRegexpOptions: {"strict":true},
    name: "werk-fagron___en"
  }, {
    path: "/work/ferring/",
    component: _f737c5b6,
    pathToRegexpOptions: {"strict":true},
    name: "werk-ferring___en"
  }, {
    path: "/work/jump-the-q/",
    component: _1e9c2744,
    pathToRegexpOptions: {"strict":true},
    name: "werk-jump-the-q___en"
  }, {
    path: "/work/nines/",
    component: _0e210263,
    pathToRegexpOptions: {"strict":true},
    name: "werk-nines___en"
  }, {
    path: "/work/rembrandt/",
    component: _89d6216e,
    pathToRegexpOptions: {"strict":true},
    name: "werk-rembrandt___en"
  }, {
    path: "/work/sonnema-1860/",
    component: _21923d5f,
    pathToRegexpOptions: {"strict":true},
    name: "werk-sonnema-1860___en"
  }, {
    path: "/",
    component: _2dfb1658,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
